// ===== Scroll Animations (IntersectionObserver) =====
document.addEventListener('DOMContentLoaded', function () {
  // Fade-in animations
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    },
    { threshold: 0.1 }
  );

  document.querySelectorAll('.fade-in-up, .fade-in').forEach(function (el) {
    observer.observe(el);
  });

  // Header scroll effect
  var header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 100) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    });
  }

  // NOTE:
  // Hero interactions and order overlay were removed on purpose.
  // Hero is now fully handled inside sections/hero.liquid (scoped per section).
});
